import React, { useRef, useState, useEffect } from "react";

import Tooltip from "../tooltip";
import { Placement } from "react-bootstrap/esm/types";

import cx from 'classnames';
import styles from "./truncateWithTooltip.module.scss";

interface TruncatedTooltipProps {
  text: string;
  placement?: Placement;
  className?: string;
  style?: React.CSSProperties;
  show?: boolean;
}

const TruncateWithTooltip: React.FC<TruncatedTooltipProps> = ({
  text,
  placement = "top",
  className,
  style,
  show,
}) => {
  const textRef = useRef<HTMLDivElement | null>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const el = textRef.current;
    if (el) {
      setIsTruncated(el.scrollWidth > el.clientWidth);
    }
  }, [text]);

  return (
    <Tooltip content={text} placement={placement} disabled={!isTruncated} show={show}>
      <div
        ref={textRef}
        className={cx(styles.truncatedText, className)}
        style={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          ...style,
        }}
      >
        {text}
      </div>
    </Tooltip>
  );
};
export default TruncateWithTooltip;